import * as R from 'ramda'
import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import { useSelector } from 'react-redux'

import * as Herz from '@rushplay/herz'
import {
  SupportChat as Component,
  getTabVisibility,
} from '@rushplay/support-chat'

import * as Player from './redux-player'
import * as Configuration from './redux-configuration'
import * as Suspense from './suspense'
import * as AppConfig from './app-config'
import * as Utils from './utils'

export function SupportChat(props) {
  const translate = Herz.I18n.useTranslate()
  const session = Herz.Auth.useSession()
  const [language] = AppConfig.useLanguage()
  const [allowLoad, setAllowLoad] = React.useState(false)
  const { liveChatKey } = Utils.Configuration.useConfiguration()
  const visible = useSelector((state) => getTabVisibility(state.supportChat))
  const location = ReactRouter.useLocation()
  const name = useSelector((state) => Player.getName(state.player))
  const email = useSelector((state) => Player.getEmail(state.player))
  const birthdate = useSelector((state) => Player.getBirthdate(state.player))
  const username = useSelector((state) => Player.getUsername(state.player))
  const depositAttempts = useSelector((state) =>
    Player.getDepositAttempts(state.player)
  )
  const depositCount = useSelector((state) =>
    Player.getDepositCount(state.player)
  )

  const department = useSelector((state) =>
    Configuration.getLiveChatDepartment(state.configuration, language)
  )

  const failedFirstDepositTag =
    depositCount === 0 && depositAttempts > 0 ? 'failed-first-deposit' : null
  const birthdateTag = birthdate ? `DOB: ${birthdate}` : null

  const valueSegment = useSelector((state) =>
    Player.getValueSegment(state.player)
  )
  const valueSegmentTag = valueSegment ? `Value segment: ${valueSegment}` : null

  const displayName = name && `${name} (${username})`

  /**
   * Only load the chat if requested or if the user is logged in
   */
  React.useEffect(() => {
    if (visible || session.authenticated) {
      setAllowLoad(true)
    }
  }, [visible, session.authenticated])

  const translations = {
    'chat.concierge.avatarPath': translate('chat.concierge.avatar'),
    'chat.concierge.name': translate('chat.concierge.name'),
    'chat.concierge.title': translate('chat.concierge.title'),
    'chat.offlineForm.greeting': translate('chat.offline-form.greeting'),
    'chat.title': translate('chat.title'),
    'launcher.chatLabel': translate('chat.launcher.chat-label'),
    'launcher.label': translate('chat.launcher.label'),
  }

  const isHidden = ['play', 'play-live', 'betting'].some((path) =>
    location.pathname.includes(path)
  )

  if (allowLoad && liveChatKey) {
    return (
      <Suspense.Boundary fallback={null}>
        <Component
          {...props}
          addScriptInHead
          hideWhenOffline
          forceOpenOnUnreadMsgs={Boolean(failedFirstDepositTag)}
          appKey={liveChatKey}
          departmentId={department.primary}
          fallbackDepartmentId={department.fallback}
          language={language}
          email={email}
          name={displayName}
          mountPoint="supportChat"
          tags={R.filter(
            (item) => !R.isNil(item),
            [birthdateTag, failedFirstDepositTag, valueSegmentTag]
          )}
          translations={translations}
          visibleAt={isHidden ? 9999 : 800}
        />
      </Suspense.Boundary>
    )
  }

  return null
}

Herz.I18n.Loader.preload(
  [
    'chat.concierge.avatar',
    'chat.concierge.name',
    'chat.concierge.title',
    'chat.offline-form.greeting',
    'chat.title',
    'chat.launcher.chat-label',
    'chat.launcher.label',
  ],
  SupportChat
)

export default SupportChat
